export default () => ({
  card: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
});
